import { Component, inject } from '@angular/core';
import { AuthService } from '../../shared/services/auth/auth.service';

@Component({
  selector: 'app-logout-overlay',
  template: `
    @if (loggingOut()) {
      <div class="fixed inset-0 z-[99999] flex min-h-screen flex-col items-center justify-center bg-white">
        <img
          src="assets/images/loading.svg"
          alt="HomeBuyer Logo"
          class="h-auto w-1/2 md:w-96"
        />
        <p class="font-outfit mt-6 text-base tracking-wide text-gray-400">
          Signing out&hellip;
        </p>
      </div>
    }
  `,
})
export class LogoutOverlayComponent {
  private readonly authService = inject(AuthService);
  protected readonly loggingOut = this.authService.loggingOut;
}
